import { createSelector } from "reselect";
import * as R from "ramda";
import { getters as TabGetters } from "ui-kit/Tabs";
import { getters } from "EventLight/Sessions/PortalSessionModal/model";
import {
  TABS_CONTENT,
  TABS,
  SESSION_MODAL_TABS_INSTANCE_ID
} from "EventLight/Sessions/PortalSessionModal/constants";

export const getCurrentTab = createSelector(
  state =>
    TabGetters.selectedTab(state, {
      instanceId: SESSION_MODAL_TABS_INSTANCE_ID
    }),
  tab => tab || TABS.CONTENT
);

export const getTabsList = createSelector(
  getters.sessionId,
  getters.data,
  (sessionId, data) => {
    const { isSpeaker = false, isSubsession = false } = data || {};
    let tabsToUse = TABS_CONTENT;
    if (!isSpeaker && isSubsession) {
      tabsToUse = R.reject(R.propEq("id", TABS.CONTENT), tabsToUse);
    }

    return tabsToUse.map(tab => ({
      ...tab,
      disabled:
        [TABS.DETAILS, TABS.CONTENT, TABS.MESSAGES, TABS.ACTIVITY].includes(
          tab.id
        ) && !sessionId,
      tooltip:
        [TABS.DETAILS, TABS.CONTENT, TABS.MESSAGES, TABS.ACTIVITY].includes(
          tab.id
        ) && !sessionId
          ? "You can access this after saving the session"
          : null
    }));
  }
);

export const getDefaultTab = createSelector(getTabsList, tabList => {
  if (R.isEmpty(tabList[0].id)) {
    return TABS.DETAILS;
  } else {
    return tabList[0].id;
  }
});

export const getIsValid = createSelector(getters.data, data => {
  if (!data.title || !data.title.length) {
    return false;
  }

  return true;
});
